module.exports = __webpack_public_path__ + "4bf89b8de7f6729575fc3217e35c1a69.ttf";